










































import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";

/**
 * Utils
 */
import * as imageLinks from "@/config/image-links";
import classes from "@/config/wow/classes";

/**
 * Helpers
 */

/**
 * Mixins
 */

/**
 * Components
 */
import Dialog from "@/components/_global/Dialog.vue";

/**
 * API
 */
import raidsAPI from "@/api/raids";
import compositionsAPI from "@/api/compositions";
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";
import { DateOnlyString } from "@/domain/date-only-string";
import { Guid } from "@/domain/guid";
import { RaidGroupResponse } from "@/api/raids/get-raid-groups.response";

/**
 * VueX Modules
 */
const teamModule = namespace("team");

interface Form {
	name: string;
	date: DateOnlyString;
	selectedInstance: string | null;
}

/**
 * Create composition group modal.
 */
@Component
export default class CreateCompositionGroupDialog extends Vue {
	$refs!: {
		modal: Dialog;
	};

	/// Injections
	imageLinks = imageLinks;
	classes = classes;

	/// Properties
	@Prop()
	onAfterCreate!: (id: any) => Promise<void>;

	/// Attributes
	isLoading = false;
	raids: any[] | null = null;
	raidGroups: RaidGroupResponse[] | null = null;

	get displayedRaids() {
		const items: any[] = [{
			name: this.$t("composition.no_instance"),
			value: null,
			zoneID: null
		}];
		if (this.raidGroups && this.raidGroups.length > 0) {
			for (const rg of this.raidGroups) {
				items.push({
					name: rg.name,
					value: "rg:" + rg.id,
					zoneID: rg.zoneID
				});
			}
		}
		if (this.raids) {
			for (const r of this.raids) {
				items.push({
					name: r.name,
					value: r.id,
					zoneID: r.zoneID
				});
			}
		}
		return items;
	}

	/// VueX Modules
	@teamModule.State("team")
	currentTeam!: GetOneTeamResponse;

	// Form
	form: Form | null = null;

	get canSubmit() {
		return this.form?.name;
	}

	/// Methods
	async open(date: DateOnlyString) {
		this.$refs.modal.open();

		this.form = {
			name: "",
			date: date,
			selectedInstance: null
		};

		await this.refreshRaids();
	}

	close() {
		this.$refs.modal.close();
	}

	async refreshRaids() {
		const [raids, raidGroups] = await Promise.all([
			raidsAPI.fetchRaids(),
			raidsAPI.fetchRaidGroups()
		]);
		this.raids = raids;
		this.raidGroups = raidGroups;
	}

	async handleCreateCompositionGroupClick() {
		const form = this.form;
		if (!this.canSubmit || form == null) {
			return;
		}

		let raidID: Guid | null = null;
		let raidGroupID: Guid | null = null;

		if (form.selectedInstance != null) {
			if (form.selectedInstance.startsWith("rg:")) {
				raidGroupID = form.selectedInstance.substring(3);
			} else {
				raidID = form.selectedInstance;
			}
		}

		this.isLoading = true;
		try {
			const id = await compositionsAPI.createComposition(this.currentTeam.id, {
				name: form.name,
				date: form.date,
				raidID: raidID,
				raidGroupID: raidGroupID
			});
			if (this.onAfterCreate) {
				await this.onAfterCreate(id);
			}
			this.close();
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}
}
